import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import parse from "html-react-parser";

interface ShowCategoryCategoryProps {
  onShowModal: boolean;
  setShowModal: (visible: boolean) => void;
  title: string;
  documents: Array<string>;
}

const ShowCategory: React.FC<ShowCategoryCategoryProps> = ({
  onShowModal,
  setShowModal,
  title,
  documents,
}) => {
  const { t } = useTranslation();

  const onClose = () => {
    setShowModal(false);
  };

  const kopeshtItems = documents.filter((item: any) => item.type === "kopesht");

  return (
    <Modal isOpen={onShowModal} toggle={() => onClose()} size="md" centered>
      <ModalHeader
        className="text-dark font-size-15"
        toggle={() => onClose()}
        tag="span"
      >
        {title}
      </ModalHeader>
      <ModalBody>
        <div className="modal-info">
         {kopeshtItems.length > 0 ? (
            <>
              <div className="modal-bold-text mb-1">
                {t("childrens_categories_view_kindergarten")}
              </div>
              <ul>
                {kopeshtItems.map((test: any, index: number) => (
                  <li key={index}>{test.title}</li>
                ))}
              </ul>
            </>
          ) : (
            ""
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          className="button-white"
          type="button"
          onClick={() => onClose()}
        >
          {t("childrens_categories_edit_cancel")}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default ShowCategory;
